import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

import { recommendationsApi } from "@/react/api/recommendations/recommendationsApi";

export const useDismissRecommendation = (
  options?: UseMutationOptions<any, Error, string>,
) =>
  useMutation({
    mutationFn: (recommendationId: string) =>
      recommendationsApi.dismissRecommendation(recommendationId),
    ...options,
  });
